import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const ZoomIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 36 36" {...props}>
      <path
        d="M16.5 28.5C23.1271 28.5 28.5 23.1271 28.5 16.5C28.5 9.87293 23.1271 4.5 16.5 4.5C9.87293 4.5 4.5 9.87293 4.5 16.5C4.5 23.1271 9.87293 28.5 16.5 28.5Z"
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.5 31.5L24.975 24.975"
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default ZoomIcon;
